import * as Yup from 'yup'
import { useClearOnUnmount, useFieldHelpers } from '@/base'
import { FormField, FormFieldProps } from '.'
import {
  DatePicker,
  DatePickerProps as BaseDatePickerProps,
} from '../datepicker'

export const FormDateInput = ({
  name,
  schema,
  shouldClearOnDismount,
  label,
  message,
  description,
  optionalText,
  ...rest
}: Omit<BaseDatePickerProps, 'value' | 'onChange'> &
  Omit<FormFieldProps, 'children'> & {
    schema?:
      | Yup.StringSchema<string | null | undefined>
      | Yup.DateSchema<Date | null | undefined>
    shouldClearOnDismount?: boolean
  }) => {
  const { field, helpers } = useFieldHelpers({ name, schema })
  useClearOnUnmount(shouldClearOnDismount, helpers.setValue)

  return (
    <FormField
      name={name}
      label={label}
      schema={schema}
      message={message}
      description={description}
      optionalText={optionalText}
    >
      <DatePicker
        {...rest}
        value={field.value}
        onChange={(value: string) => helpers.setValue(value)}
      />
    </FormField>
  )
}
